module.exports = __webpack_public_path__ + "static/media/combat(26).dd7edde3.PNG";